import React from 'react';
import ReactTooltip from 'react-tooltip';
import {
	Loader,
	BaasicTable,
	BaasicModal,
	TableFilter,
	BaasicConfirmModal,
	BaasicCheckbox,
	BaasicSelect,
	BaasicHeader,
	BaasicTableExport,
	NotifyOutsideClick,
} from 'core/components';
import { observer } from 'mobx-react';
import { defaultTemplate } from 'core/hoc';
import { FileNames, fulfillmentOrdersGroupByOptions } from 'common/constants';
import {
	AssignCarrierServiceAndWarehouse,
	LabelingMode,
	PalletizingMode,
	ExitScanMode,
	Tracking,
	ExportLabels,
	OnHold,
	ChangeShipping,
	CloseOutExit,
	CloseOutPalletizing,
	StatusChange,
	VoidLabel,
	NeverShipped,
	ExportToCSVByDate,
	MarkAsShipped,
	MarkAsShippedBulk,
	EditOrder,
	UpdateBuyShipping,
	BulkPrint,
	BulkPrintHistory,
	BulkPrintHistoryCreate,
	FulfillmentOrderItemsExpandList,
	SplitFulfillmentOrder,
} from 'modules/order/pages';
import _ from 'lodash';
import OrderDateRangeFilter from 'modules/order/pages/OrderDateRangeFilter';

const OrderListTemplate = ({
	t,
	viewStore,
	viewStore: {
		loading,
		listStore,
		tableData,
		baasicTableSettingsViewStore,
		queryUtility,
		columnFilterSetup,
		removeFiltersModal: { removeFiltersConfirm },
		assignmentModal,
		assignModalBulk,
		palletizingModeModal,
		selectedItem,
		selectedItems,
		labelingModeModal,
		exitScanModeModal,
		trackingModal,
		exportLabelsModal,
		onHoldModal,
		onHoldBulkModal,
		cancelConfirmModal,
		bulkPrintHistoryCreateModal,
		changeShippingModal,
		closeOutExitModal,
		closeOutPalletizingModal,
		changeShippingModalBulk,
		splitFulfillmentOrderModal,
		pdfURL,
		pdfURLReturn,
		isSeller,
		updateBuyShippingModalBulk,
		isBulkPrintMode,
		isPickingMode,
		statusChangeModal,
		voidLabelModal,
		neverShippedModal,
		markAsShippedModal,
		closeOutPalletizingConfirmModal,
		closeOutExitScanConfirmModal,
		voidLabelConfirmModal,
		findFulfillmentOrders,
		isSuperAdminOrganization,
		selectedWarehouse,
		onSelectAllCheckbox,
		isSelectAllCheckboxSelected,
		showSelectAllColumn,
		onSelectFulfillmentOrderCheckbox,
		pullLabelConfirmModal,
		pullLabelBulkConfirmModal,
		reoptimizeConfirmModal,
		reoptimizeConfirmModalBulk,
		editOrderModal,
		markAsShippedModalBulk,
		group,
		expandChange,
		groupable,
		change,
		bulkPrintModal,
		bulkPrintHistoryModal,
		pullLabelProductionModeConfirmModal,
		selectedGroupByOption,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader
				title="MAINMENU.FULFILLMENTORDERS.TITLE"
				baasicTableSettingsViewStore={baasicTableSettingsViewStore}
				reloadFunc={findFulfillmentOrders}
				disabledBtn={isSeller || isSuperAdminOrganization ? isPickingMode && selectedWarehouse == null : false}
			>
				<HeaderComponents {...{ viewStore, t }} />
				<BaasicTableExport tableViewStore={viewStore} fileTitle={FileNames.FulfillmentOrder} />
			</BaasicHeader>
			<div className={`k-grid--bulk ${selectedGroupByOption ? 'group' : ''}`}>
				<BaasicTable
					{...{
						tableData,
						queryUtility,
						viewStore,
						showActions: isPickingMode || isBulkPrintMode ? false : true,
						detailComponent: FulfillmentOrderItemsExpandList,
						isSelectAllCheckboxSelected,
						groupable,
						group,
						expandChange,
						change,
					}}
					rowRender={CustomRowRender} // Production mode: Row has red background. Is multi item: Expand button is visible, else hidden.
					cellRender={CellRender}
					data={listStore.data.slice()}
					actions={viewStore}
					onSelectAllHeaderClick={onSelectAllCheckbox}
					showSelectAllColumn={showSelectAllColumn}
					onCheckboxChange={onSelectFulfillmentOrderCheckbox}
				/>
			</div>
			<TableFilter viewStore={viewStore} columnFilterSetup={columnFilterSetup} />
			<BaasicConfirmModal modalParams={removeFiltersConfirm} />
			<BaasicConfirmModal modalParams={cancelConfirmModal} />
			<BaasicConfirmModal modalParams={pullLabelConfirmModal} />
			<BaasicConfirmModal modalParams={pullLabelBulkConfirmModal} />
			<BaasicConfirmModal modalParams={pullLabelProductionModeConfirmModal} />
			<BaasicConfirmModal modalParams={closeOutPalletizingConfirmModal} />
			<BaasicConfirmModal modalParams={closeOutExitScanConfirmModal} />
			<BaasicConfirmModal modalParams={voidLabelConfirmModal} />
			<BaasicConfirmModal modalParams={reoptimizeConfirmModal} />
			<BaasicConfirmModal modalParams={reoptimizeConfirmModalBulk} />
			<BaasicModal modalParams={assignModalBulk}>
				<AssignCarrierServiceAndWarehouse
					selectedItemIds={selectedItems != null ? selectedItems.map(item => item.id) : null}
					parentViewStore={viewStore}
				/>
			</BaasicModal>
			<BaasicModal modalParams={onHoldBulkModal}>
				<OnHold
					selectedItemIds={selectedItems != null ? selectedItems.map(item => item.id) : null}
					parentViewStore={viewStore}
				/>
			</BaasicModal>
			<BaasicModal modalParams={updateBuyShippingModalBulk}>
				<UpdateBuyShipping selectedItems={selectedItems} parentViewStore={viewStore} />
			</BaasicModal>
			<BaasicModal modalParams={changeShippingModalBulk}>
				<ChangeShipping
					selectedItemIds={selectedItems != null ? selectedItems.map(item => item.id) : null}
					elingModeViewStore
					parentViewStore={viewStore}
				/>
			</BaasicModal>
			<BaasicModal modalParams={assignmentModal}>
				<AssignCarrierServiceAndWarehouse
					parentViewStore={viewStore}
					selectedItemId={selectedItem != null ? selectedItem.id : null}
				/>
			</BaasicModal>

			<BaasicModal className="ReactModal--lrg" modalParams={labelingModeModal}>
				<LabelingMode />
			</BaasicModal>

			<BaasicModal className="ReactModal--lrg" modalParams={splitFulfillmentOrderModal}>
				<SplitFulfillmentOrder
					selectedItemId={selectedItem != null ? selectedItem.id : null}
					selectedMarketplaceOrderId={selectedItem != null ? selectedItem.orderId : null}
					parentViewStore={viewStore}
					modalParams={splitFulfillmentOrderModal}
				/>
			</BaasicModal>
			<BaasicModal className="ReactModal--lrg" modalParams={palletizingModeModal}>
				<PalletizingMode />
			</BaasicModal>
			<BaasicModal className="ReactModal--lrg" modalParams={exitScanModeModal}>
				<ExitScanMode />
			</BaasicModal>
			<BaasicModal modalParams={trackingModal}>
				<Tracking />
			</BaasicModal>
			<BaasicModal modalParams={exportLabelsModal}>
				<ExportLabels />
			</BaasicModal>
			<BaasicModal modalParams={onHoldModal}>
				<OnHold parentViewStore={viewStore} selectedItemId={selectedItem != null ? selectedItem.id : null} />
			</BaasicModal>
			<BaasicModal modalParams={editOrderModal}>
				<EditOrder selectedItemId={selectedItem != null ? selectedItem.id : null} parentViewStore={viewStore} />
			</BaasicModal>
			<BaasicModal modalParams={changeShippingModal}>
				<ChangeShipping selectedItemId={selectedItem != null ? selectedItem.id : null} parentViewStore={viewStore} />
			</BaasicModal>
			<BaasicModal modalParams={statusChangeModal}>
				<StatusChange selectedItemId={selectedItem != null ? selectedItem.id : null} parentViewStore={viewStore} />
			</BaasicModal>
			<BaasicModal modalParams={voidLabelModal}>
				<VoidLabel selectedItemId={selectedItem != null ? selectedItem.id : null} parentViewStore={viewStore} />
			</BaasicModal>
			<BaasicModal modalParams={neverShippedModal}>
				<NeverShipped selectedItemId={selectedItem != null ? selectedItem.id : null} parentViewStore={viewStore} />
			</BaasicModal>
			<BaasicModal modalParams={closeOutExitModal}>
				<CloseOutExit />
			</BaasicModal>
			<BaasicModal modalParams={closeOutPalletizingModal}>
				<CloseOutPalletizing />
			</BaasicModal>
			<BaasicModal modalParams={markAsShippedModal}>
				<MarkAsShipped selectedItemId={selectedItem != null ? selectedItem.id : null} parentViewStore={viewStore} />
			</BaasicModal>
			<BaasicModal className="ReactModal--xlrg" modalParams={markAsShippedModalBulk}>
				<MarkAsShippedBulk parentViewStore={viewStore} />
			</BaasicModal>
			<ReactTooltip />
			<BaasicModal className="ReactModal--bulk-print" modalParams={bulkPrintModal}>
				<BulkPrint parentViewStore={viewStore} />
			</BaasicModal>
			<BaasicModal className="ReactModal--lrg" modalParams={bulkPrintHistoryModal}>
				<BulkPrintHistory />
			</BaasicModal>
			<BaasicModal modalParams={bulkPrintHistoryCreateModal}>
				<BulkPrintHistoryCreate />
			</BaasicModal>
			<iframe id="pdf-print" name="pdf-print" src={pdfURL} style={{ display: 'none' }}></iframe>
			<iframe id="pdf-print-return" name="pdf-print-return" src={pdfURLReturn} style={{ display: 'none' }}></iframe>
		</section>
	);
};

const HeaderComponents = observer(({ viewStore, t }) => {
	const {
		bulkActionsArray,
		toggleBulkMenu,
		closePopup,
		isBulkActionPopupOpen,
		onWarehouseSelect,
		handleOnMenuScroll,
		isWarehouseDropdownLoading,
		onMenuClose,
		selectedGroupByOption,
		onGroupBySelect,
		debouncedWarehouseSearch,
		warehouseOptions,
		useRegularPalletizingMode,
		onWarehouseSettingCheck,
		onCheck,
		showTodayShipments,
		isBulkPrintMode,
		isSeller,
		isSuperAdminOrganization,
		selectedItems,
		isPickingMode,
		selectedWarehouse,
		orderDateRangeViewStore,
	} = viewStore;
	return (
		<div className="flex--primary flex--align--middle align--h--right">
			{!showTodayShipments && <OrderDateRangeFilter orderDateRangeViewStore={orderDateRangeViewStore} />}

			<BaasicSelect
				placeholder={t('ORDERVIEW.PLACEHOLDER.GROUPBYSELECT')}
				options={fulfillmentOrdersGroupByOptions}
				value={selectedGroupByOption}
				isClearable={true}
				isSearchable={false}
				onChange={onGroupBySelect}
				className="w--200--px spc--right--med"
			/>
			{(isSeller || isSuperAdminOrganization) && isPickingMode && (
				<BaasicSelect
					placeholder={t('ORDERVIEW.PLACEHOLDER.WAREHOUSESELECT')}
					options={warehouseOptions.slice()}
					value={selectedWarehouse}
					onChange={onWarehouseSelect}
					isLoading={isWarehouseDropdownLoading}
					onMenuScrollToBottom={handleOnMenuScroll}
					onInputChange={debouncedWarehouseSearch}
					onMenuClose={onMenuClose}
					className="w--200--px spc--right--med"
				/>
			)}
			{!isPickingMode && (isSeller || isSuperAdminOrganization) && !isBulkPrintMode && selectedItems.length > 0 && (
				<div className="header__left--mode">
					<NotifyOutsideClick action={closePopup}>
						<div className="header__profile" onClick={toggleBulkMenu}>
							<div>
								<span className="spc--right--tny">{t('ORDERVIEW.PLACEHOLDER.BULKACTIONSELECT')}</span>
								<i className="fa fa-angle-down spc--left--med" />
							</div>
							<div className={'header__profile--dropdown' + (isBulkActionPopupOpen ? ' active' : '')}>
								<ul>
									{_.map(bulkActionsArray, mode => {
										return (
											<li key={mode.id} className="header__profile--dropdown__item" onClick={mode.onClick}>
												{t(mode.name)}
											</li>
										);
									})}
								</ul>
							</div>
						</div>
					</NotifyOutsideClick>
				</div>
			)}
			{!isSeller && !isSuperAdminOrganization && (
				<div className="layout__main__subheader__item">
					<BaasicCheckbox
						id={'useRegularPalletizingMode'}
						onChange={onWarehouseSettingCheck}
						label="ORDERVIEW.USEREGULARPALLETIZINGMODE"
						checked={useRegularPalletizingMode}
						className="input--check input--check--negative"
					/>
				</div>
			)}
			<div className="layout__main__subheader__item">
				<BaasicCheckbox
					id={'showTodayShipments'}
					onChange={onCheck}
					label="ORDERVIEW.SHOWTODAYSHIPMENTS"
					checked={showTodayShipments}
					className="input--check input--check--negative"
				/>
			</div>
			<ExportToCSVByDate />
		</div>
	);
});

function CustomRowRender(trElement, { dataItem }) {
	const isMultiItem = _.has(dataItem, 'orderedItemCount') ? dataItem.orderedItemCount > 1 : null;
	let className = '';
	if (isMultiItem) {
		className = dataItem.productionMode ? trElement.props.className + ' is-warning' : trElement.props.className;
	} else {
		className = dataItem.productionMode
			? 'not-expandable ' + trElement.props.className + ' is-warning'
			: 'not-expandable ' + trElement.props.className;
	}
	return <tr className={className}>{trElement.props.children}</tr>;
}

function CellRender(td, props) {
	if (td && td.props.children && props.rowType === 'groupHeader' && props.dataItem.showSelectCheckbox) {
		let children = (
			<div className="flex--primary">
				<div className="spc--right--sml">
					<BaasicCheckbox
						id={props.dataItem.value}
						checked={props.dataItem.isChecked}
						onChange={() => props.dataItem.onSelectGroupCheckbox(props.dataItem)}
						className={`input--check ${props.dataItem.isPartiallyChecked ? 'input--check--partially' : ''}`}
					/>
				</div>
				{td.props.children}
			</div>
		);
		return React.cloneElement(td, td.props, children);
	}
	return td;
}

export default defaultTemplate(OrderListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/OrderListTemplate.jsx